import { AboutData } from '../types';

const aboutData: AboutData = {
  title: "Ich erzähle Dir was über mich.",
  intro: [
    "Ich bin Robin Wichmann, ein erfahrener Frontend-Entwickler mit über {yearsExp} Jahren Erfahrung in der Webentwicklung. Meine Leidenschaft liegt darin, ansprechende und benutzerfreundliche Interfaces zu gestalten, die nicht nur gut aussehen, sondern auch optimal funktionieren.",
    "Im Laufe meiner Karriere habe ich mit zahlreichen Technologien und Frameworks gearbeitet, darunter React, Vue.js, Next.js und TypeScript, Flutter mit Dart oder neuerdings auch gerne Python für Deep Learning Experimente. ",
    "Mein Fokus liegt stets auf Clean Code, Performance-Optimierung und barrierefreiem Design."
  ],
  buttons: {
    work: "Meine Arbeiten",
    contact: "Kontakt"
  },
  skillsTitle: "Meine Skills & Expertise",
  skillCategories: [
    {
      name: "Frontend-Technologien",
      skills: [
        { name: "HTML", verified: true, companies: 6 },
        { name: "CSS", verified: true, companies: 6 },
        { name: "JavaScript", verified: true, companies: 7 },
        { name: "TypeScript", verified: true, companies: 4 },
        { name: "React.js", verified: false, companies: 3 },
        { name: "Vue.js", verified: false, companies: 2 },
        { name: "Next.js", verified: false, companies: 2 },
        { name: "SASS/SCSS", verified: true, companies: 3 },
        { name: "Responsive Design", verified: true, companies: 3 },
        { name: "Web Standards", verified: true, companies: 5 }
      ]
    },
    {
      name: "Tools & Plattformen",
      skills: [
        { name: "Git", verified: true, companies: 4 },
        { name: "Webpack", verified: true, companies: 2 },
        { name: "Contentful", verified: false, companies: 2 },
        { name: "Firebase", verified: false, companies: 1 },
        { name: "Storybook", verified: false, companies: 1 },
        { name: "PhpStorm", verified: false, companies: 6 },
        { name: "Mac", verified: false, companies: 6 },
        { name: "Unix/Shell", verified: false, companies: 6 }
      ]
    },
    {
      name: "Mobile & Apps",
      skills: [
        { name: "iOS", verified: false, companies: 5 },
        { name: "Android", verified: false, companies: 5 },
        { name: "Flutter", verified: false, companies: 1 },
        { name: "Swift", verified: false, companies: 2 },
        { name: "React Native", verified: false, companies: 1 }
      ]
    },
    {
      name: "Backend & Server",
      skills: [
        { name: "Node.js", verified: false, companies: 2 },
        { name: "RESTful Services", verified: true, companies: 4 },
        { name: "PHP", verified: false, companies: 2 },
        { name: "SQL", verified: false, companies: 2 },
        { name: "Apache", verified: false, companies: 3 },
        { name: "Web Assembly", verified: false, companies: 1 }
      ]
    },
    {
      name: "KI & Zukunftstechnologien",
      skills: [
        { name: "Generative KI", verified: false, companies: 2 },
        { name: "LLM Operations", verified: false, companies: 2 },
        { name: "Web Vitals", verified: false, companies: 1 },
        { name: "Performance", verified: false, companies: 4 }
      ]
    },
    {
      name: "Methoden & Management",
      skills: [
        { name: "Agile Methoden", verified: false, companies: 5 },
        { name: "Teamkoordination", verified: false, companies: 1 },
        { name: "Team-Building", verified: false, companies: 1 },
        { name: "Problemlösung", verified: false, companies: 7 },
        { name: "E-Commerce", verified: false, companies: 2 },
        { name: "UX/UI Design", verified: true, companies: 6 }
      ]
    }
  ],
  careerTitle: "Mein Werdegang",
  verifiedLabel: "Verifiziert",
  companiesLabel: "Unternehmen",
  careerTimeline: [
    {
      year: "Mai 2024 - Heute",
      title: "Teamleiter / Tech Lead",
      company: "apo.com Group GmbH",
      description: "Leitung des Frontend-Teams, Verantwortung für Webtechnologien und E-Commerce-Lösungen. Strategische Planung und Koordination von Entwicklungsprojekten.",
      location: "Markkleeberg",
      tasks: [
        "Teamführung und Personalverantwortung inkl. Recruiting und Hiring-Prozesse",
        "Mentoring und Coaching von Teammitgliedern",
        "Technische Bewertung von Machbarkeiten und Ressourcenplanung",
        "Consulting für andere Fachbereiche und Gewerke",
        "Strategisches Prototyping für neue Technologien und Lösungsansätze",
        "Organisation von Fortbildungsmaßnahmen und Wissenstransfer",
        "Technische Entscheidungsfindung und Architektur-Design",
        "Koordination zwischen Produktmanagement und Entwicklungsteam"
      ],
      companyType: "Arzneimittel-Versandhändler"
    },
    {
      year: "März 2023 - Heute",
      title: "Frontend Developer",
      company: "apo.com Group GmbH",
      description: "Ich bin verantwortlich für die Frontend-Entwicklung und Optimierung diverser Online-Shops und Middleware-Implementierungen, mit Fokus auf React, Mobile App Development und SEO.",
      location: "Markkleeberg",
      tasks: [
        "Konzeption, Entwicklung und Betreuung diverser Online-Shops und Middleware Implementierungen",
        "Dynamische React Komponenten",
        "SEO und Pagespeed Optimierungen",
        "Definition von Code Conventions für das Team bzgl. Typescript und OOP",
        "Mobile und Desktop App Development",
        "Engineering (Webpack, Vite, Parcel…)",
        "Diverse Prototypen (u.A. Canvas, React, Vue, Storybook, StoryToDesign, Firebase Auth & RT Database)",
        "Flutter, Titanium",
        "Anlegen und Analyse von Tags und Events für GTM und GA",
        "Marketingtools und Kampagnen"
      ],
      companyType: "Arzneimittel-Versandhändler"
    },
    {
      year: "Februar 2017 - März 2023",
      title: "Senior Frontend Developer",
      company: "Plan A Internet",
      description: "Als Senior Frontend Developer bin ich zuständig für die Konzeption und Entwicklung von modernen Webseiten, Single Page Applications und Server-First Components mit Schwerpunkt auf Performance und Nutzererfahrung.",
      location: "Hamburg",
      tasks: [
        "Konzeption, Entwicklung und Betreuung klassischer Webseiten, SPA, SFC",
        "Implementierung dynamischer Trackinglösungen",
        "SEO"
      ],
      clients: ["TV-Spielfilm", "Fit for Fun", "FRoSTA", "tesa", "Hapag Lloyd", "Gruner + Jahr"],
      companyType: "Werbeagentur"
    },
    {
      year: "Oktober 2015 - Januar 2017",
      title: "Freelance Web Developer",
      company: "Freiberuflich",
      description: "Als freiberuflicher Webentwickler habe ich für renommierte Kunden moderne Webseiten und Anwendungen entwickelt, von der Konzeption bis zur finalen Umsetzung.",
      location: "Hamburg",
      tasks: [
        "Konzeption und Entwicklung klassischer Webseiten und Single Page Applications",
        "Implementierung dynamischer Trackinglösungen",
        "Werbemittel-Entwicklung"
      ],
      clients: ["Volkswagen", "Netflix", "Mercedes", "tesa", "Yogi Tea"]
    },
    {
      year: "Januar 2012 - Oktober 2015",
      title: "Flash Developer / Web Developer",
      company: "Grabarz & Partner Werbeagentur",
      description: "Bei Grabarz & Partner war ich verantwortlich für die Entwicklung innovativer Web-Specials und Landingpages für den internationalen Markt, sowie für die Betreuung der Auszubildenden und Organisation von Entwickler-Events.",
      location: "Hamburg",
      tasks: [
        "Konzeption und Entwicklung dynamischer Web-Specials und Landingpages; mehrsprachig für den internationalen Markt",
        "Werbemittel-Entwicklung",
        "Betreuung der Auszubildenden",
        "Organisation öffentlicher Events als Möglichkeit des Recruitungs (\"Code in the Dark\")"
      ],
      clients: ["Volkswagen", "Volkswagen Nutzfahrzeuge", "IKEA", "Wieners & Wieners"],
      companyType: "Werbeagentur"
    },
    {
      year: "September 2009 - November 2011",
      title: "Flash Developer",
      company: "deepblue networks",
      description: "Bei deepblue networks lag mein Fokus auf der Entwicklung dynamischer Webanwendungen (PWA) und mobiler Anwendungen mit Adobe AIR (3D), sowie der Konzeption und Umsetzung von Web-Anwendungen für bekannte Marken. Spieleentwicklung für Red Bull und Knorr.",
      location: "Hamburg",
      tasks: [
        "Entwicklung dynamischer Webanwendungen (PWA) für das Web als auch für mobile Devices (Adobe AIR)",
        "Werbemittel-Entwicklung"
      ],
      clients: ["Unilever", "Red Bull", "Imperial Tobacco Group", "Studioline", "DPD"],
      companyType: "Werbeagentur"
    },
    {
      year: "Februar 2009 - September 2009",
      title: "Flash Developer",
      company: "Elephant Seven (Heute: Digitas Pixelpark)",
      description: "Nach meiner Ausbildung war ich zunächst als Flash Developer für die Erstellung interaktiver Werbemittel und Web-Specials für namhafte internationale Marken zuständig.",
      location: "Hamburg",
      clients: ["Mercedes", "Chrysler", "Storck", "Dräger", "Swarovski", "Red Bull", "Tchibo", "Lufthansa", "Palmers", "Montblanc"],
      companyType: "Werbeagentur"
    },
    {
      year: "September 2006 - Januar 2009",
      title: "Auszubildender - Mediengestaltung für Digital- und Printmedien (Fachrichtung Operating)",
      company: "Elephant Seven (Heute: Digitas Pixelpark)",
      description: "Während meiner Ausbildung zum Mediengestalter mit Schwerpunkt Frontend-Development erwarb ich umfassende Kenntnisse in der Entwicklung von Werbemitteln und Web-Specials für hochkarätige Kunden. Mit objektorientierter Programmierung in ActionScript 3.0 und der Entwicklung von Flash-Anwendungen konnte ich meine Fähigkeiten weiter vertiefen.",
      location: "Hamburg",
      clients: ["Mercedes", "Chrysler", "Storck", "Dräger", "Swarovski", "Red Bull", "Tchibo", "Lufthansa", "Palmers", "Montblanc"],
      companyType: "Werbeagentur"
    }
  ]
};

export default aboutData;